import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    toggleSearchBoxBoth,
    applySearchBoth
} from './../../../actions/FilterActions';
import common from '../../../common';
import { setPopupState } from '../../../actions/FormationActions';

class SearchBtnMobile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showClose: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.skill && (this.props.skill !== nextProps.skill)) {
            this.props.applySearchBoth('');
            this.props.toggleSearchBoxBoth(false);
            if (nextProps.filterSkillIds && nextProps.filterSkillIds.length) {
                this.props.toScrollToTop()
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.isSearchOpenForBoth !== prevProps.isSearchOpenForBoth && this.props.isSearchOpenForBoth) {
            this._searchInput.focus();
        }
    }

    onSearchClose = (e) => {
        e.stopPropagation();
        if (this.props.searchString) {
            this.props.applySearchBoth('');
        } else {
            this.props.toggleSearchBoxBoth(false);
        }
    };
    onSearchTap = (e) => {
        this.props.toggleSearchBoxBoth();
    };
    handleChange = (event) => {
        this.props.applySearchBoth(event.target.value);
        if (event.target.value.length > 0) {
            this.setState({
                showClose: true
            })
        } else {
            this.setState({
                showClose: false
            })
        }
    };



    render() {

        const { isSearchOpenForBoth } = this.props;
        const searchClassMob = common.makeClasses({
            'si-filter-items': true,
            'si-filter-search': true,
            'si-search-open': common.isMobile() ? isSearchOpenForBoth : false
        });

        const closeButtonClass = common.makeClasses({
            'si-hidden': false,
            'icon-ucl-close': true,
            'si-filter-icons': true

        })
        const handler = isSearchOpenForBoth ? () => {
        } : () => this.onSearchTap();
        return <div className={ searchClassMob }
            onClick={ handler }>
            <div className="si-filter-item-wrap">
                <input type="search" placeholder={ this.props.trans.search }
                    className="si-search-input"
                    value={ this.props.searchString }
                    onChange={ (e) => this.handleChange(e) }
                    ref={ (ref) => this._searchInput = ref }
                />
                <i className="icon-ucl-search si-filter-icons" />
                { common.isMobile() ? <i className={ closeButtonClass }
                    onClick={ (e) => this.onSearchClose(e) } /> : this.props.searchString ? <div className="si-close"><i className={ closeButtonClass }
                        onClick={ (e) => this.onSearchClose(e) } />
                    </div> : null }

            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        searchString: state.formationData.playerFilters.searchString,
        isSearchOpenForBoth: state.formationData.isSearchOpenForBoth,
        skill: state.formationData.currentPosition.skill,
        filterSkillIds: state.formationData.playerFilters.skillId
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        toggleSearchBoxBoth: (bool) => dispatch(toggleSearchBoxBoth(bool)),
        applySearchBoth: (str) => dispatch(applySearchBoth(str)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SearchBtnMobile);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/SearchBtnMobile.js